import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Staff from "src/components/panel/staff/Staff";
import * as AppConfig from "../../../helpers/AppConfig";

const StaffView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("staff_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("staff_list_title")}
          subtitle={t("staff_list_subtitle")}
        />
        <Staff />
      </Sidebar>
    </>
  );
};

export default StaffView;
